var exports = {
  "Wl": "EmbedGifv.module__imagePreviewHandler___RGM5QU",
  "tN": "EmbedGifv.module__blurContainer___RGM5QU",
  "rj": "EmbedGifv.module__blurContent___RGM5QU",
  "JV": "EmbedGifv.module__blurInnerContainer___RGM5QU",
  "aO": "EmbedGifv.module__thumbHashPlaceholder___RGM5QU",
  "il": "EmbedGifv.module__mediaContainer___RGM5QU",
  "M_": "EmbedGifv.module__videoWrapper___RGM5QU",
  "UD": "EmbedGifv.module__videoElement___RGM5QU",
  "qf": "EmbedGifv.module__placeholder___RGM5QU",
  "ci": "EmbedGifv.module__placeholderFastFade___RGM5QU",
  "Ap": "EmbedGifv.module__placeholderVisible___RGM5QU",
  "uR": "EmbedGifv.module__placeholderHidden___RGM5QU",
};

module.exports = exports;
